(ns app.front.view.group.admin.fees.schedule.schedule-import
  "For handling in the front end fee schedule import from an EDN file"
  (:require [ajax.core :refer [POST]]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [core.front.event :refer [>evt]]
            [core.util.util :as util]))


(defn- stop-tracking-file
  [component-id file-hash]
  (>evt [::upload/remove-pending-file component-id :placeholder])
  (>evt [::upload/remove-pending-file component-id file-hash]))


(defn process-import-file
  "Called when the user selects the imported EDN file in the UI"
  [authority-group-id {:keys [file component-id file-hash]}]
  (>evt [::upload/add-pending-file component-id file-hash])
  (POST (str "/api/command/fee/import-fee-schedule?authority-group-id=" authority-group-id)
    {:headers       {"Content-Type" "application/edn"}
     :body          file
     :error-handler (fn [{:keys [status response]}]
                      (stop-tracking-file component-id file-hash)
                      (>evt [::upload/upload-failure (util/mmap {:md5 file-hash} component-id) status response]))
     :handler       (fn [response]
                      (>evt [::entities/apply-changes 200 response])
                      (stop-tracking-file component-id file-hash)
                      (>evt [:notifications/add :toast :success :success :fees/import-success]))}))
